import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LINK_PATH } from '../../../../constant';
function GstReport() {
    const navigate = useNavigate();
    const [selectedIndex, setSelectedIndex] = useState(0);
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'ArrowDown') {
                setSelectedIndex((prevIndex) => Math.min(prevIndex + 1, totalLinks - 1));
            } else if (event.key === 'ArrowUp') {
                setSelectedIndex((prevIndex) => Math.max(prevIndex - 1, 0));
            } else if (event.key === 'Enter') {
                event.preventDefault();
                // You can navigate to the selected link's path here
                const selectedLink = accounting[selectedIndex] || inventory[selectedIndex]|| exception[selectedIndex];
                if (selectedLink) {
                    event.preventDefault();
                    navigate(selectedLink.to)
                }
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [selectedIndex]);
    const accounting = [
        { to: '/createmasters', text: 'TRack GST Return Activities' },
        { to: '/daybooktransaction', text: 'GSTR-1' },
        { to: '/chartofaccountmasters', text: 'GSTR-3B' },
        { to: '/chartofaccountmasters', text: 'Annual Computation' },
    ];
    const inventory = [];
    inventory[4] = { to: '/inventorybook', text: 'e-Way Bill' };
    const exception = [];
    exception[5] = { to: `${LINK_PATH}/balancesheetreports`, text: 'GSTR-1 Reconcilitaion' };
    exception[6] = { to: '/profitandlossac', text: 'GSTR-2A Reconcilitaion' };
    exception[7] = { to: '/profitandlossac', text: 'GSTR-2B Reconcilitaion' };
    exception[8] = { to: '/profitandlossac', text: 'Challan Reconcilitaion' };
    exception[9] = { to: '/profitandlossac', text: 'GST Utilities' };
    exception[10] = { to: '/profitandlossac', text: 'Other Reports' };
    exception[11] = { to: '/profitandlossac', text: 'Quit' };

    const totalLinks = (accounting.length + inventory.length + exception.length) - 9;
    return (
        <div className='card-container' id='card-container'>
            <div className='card-title'>
                <p className='title-of'> GST Reports</p>
            </div>
            <div className='gateway_tally_card'>
                <div className='list-1'>
                    <h6 className='list-heading'> GST RETURNS/COMPUTATIONS</h6>
                    <ul className='list-item'>
                        {accounting.map((link, index) => (
                            <li key={index} className={index === selectedIndex ? 'selected' : ''}>
                                <Link to={index === selectedIndex ? link.to : ''} onClick={() => setSelectedIndex(index)}>{link?.text}</Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className='list-1'>
                    <h6 className='list-heading'> EXCHANGE REPORTS</h6>
                    <ul className='list-item'>
                        {inventory.map((link, index) => (
                            <li key={index} className={index === selectedIndex ? 'selected' : ''}>
                                <Link to={index === selectedIndex ? link.to : ''} onClick={() => setSelectedIndex(index)}>{link?.text}</Link>
                            </li>
                        ))}
                    </ul>

                </div>
                <div className='list-1'>
                    <h6 className='list-heading'>RECONCILIATION REPORTS</h6>
                    <ul className='list-item'>
                        {exception.map((link, index) => (
                            <li key={index} className={index === selectedIndex ? 'selected' : ''}>
                                <Link to={index === selectedIndex ? link.to : ''} onClick={() => setSelectedIndex(index)}>{link?.text}</Link>
                            </li>
                        ))}

                    </ul>
                </div>
            </div>

        </div>
    )
}

export default GstReport;
